import React from 'react'
import type { FC } from 'react'
interface Props {
  className?: string;
  color?: string;
  size?: number | string;
  rotateOnRtl?: boolean;
}
export const IconIroningSet: FC<Props> = ({
  color = 'currentColor',
  size = 24,
  className,
  rotateOnRtl = false,
  ...rest
}) => {
  const props = {
    width: size,
    height: size,
    fill: color,
    // stroke: color,
    className,
    viewBox: '0 0 24 24',
    ['data-rotateonrtl']: false,
    ...rest,
  }
  return /*#__PURE__*/ React.createElement(
    'svg',
    Object.assign(
      {
        xmlns: 'http://www.w3.org/2000/svg',
        width: 24,
        height: 24,
        viewBox: '0 0 24 24',
      },
      props
    ),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M15 3h6c.6 0 1 .4 1 1v12c0 .6-.4 1-1 1H3c-.6 0-1-.4-1-1C2 8.8 7.8 3 15 3zM4 15h16V5h-5C9.3 5 4.6 9.4 4 15zm.1 4h15.8c.6 0 1.1.4 1.1 1s-.4 1-1 1H4.1c-.6 0-1-.4-1-1s.4-1 1-1zm5.9-9c0 .6.4 1 1 1h6c.6 0 1-.4 1-1V7c0-.6-.4-1-1-1h-3c-2.2 0-4 1.8-4 4zm6-1h-3.7c.3-.6 1-1 1.7-1h2v1zm-2 4c0-.6.4-1 1-1h2c.6 0 1 .4 1 1s-.4 1-1 1h-2c-.6 0-1-.4-1-1z',
      fillRule: 'evenodd',
      clipRule: 'evenodd',
    })
  )
}
